import { ConvertObjectCamelToSnakeCase } from "@/app/infrastructures/misc/Utils";
import { QueryParamsEntities2 } from "./MainApp";
import { PaginationV2 } from "./Pagination";

export class KulionerProduct {
  id = 0;
  name = "";
  thumbnail = "";
  quantity = 0;
  price = 0;
  totalPrice = 0;
  note = "";
  handlingType = "";
  actualQuantity = 0;
  isQuantityUpdated = false;
  stockEmpty = false;
  isPurchased = false;
  quantityUpdatedAt = "";

  constructor(fields?: Partial<KulionerProduct>) {
    Object.assign(this, fields);
  }
}

export class KulionerHistory {
  id = 0;
  status = "";
  label = "";
  createdAt = "";
  createdBy = "";

  constructor(fields?: Partial<KulionerHistory>) {
    Object.assign(this, fields);
  }
}

export class KulionerMerchant {
  id = 0;
  name = "";
  phoneNumber = "";
  address = "";
  thumbnail = "";
  latLon = "";
  price = 0;
  totalProduct = 0;
  totalQuantity = 0;
  totalPrice = 0;
  products: KulionerProduct[] = [];
  isExpandDetailKulioner = true;
  stockEmpty = false;
  isPurchased = false;
  actualQuantity = 0;
  actualProduct = 0;

  constructor(fields?: Partial<KulionerMerchant>) {
    Object.assign(this, fields);
  }
}

export class KulionerOrder {
  id = 0;
  status = "";
  orderId = "";
  orderShipmentId = "";
  orderSttNo = "";
  isMarkProcessed = false;
  createdAt = "";
  updatedAt = "";
  recipientName = "";
  recipientPhoneNumber = "";
  recipientAddress = "";
  productType = "";
  totalMerchant = 0;
  totalPrice = 0;
  merchants: KulionerMerchant[] = [];
  koTotalQuantity = 0;
  koMerchantName = "";
  koMerchantPhoneNumber = "";
  koMerchantAddress = "";
  histories: KulionerHistory[] = [];
  koMerchantLatlon = "";
  koProduct: KulionerProduct[] = [];
  cycleAt = "";

  constructor(fields?: Partial<KulionerOrder>) {
    Object.assign(this, fields);
  }
}

export class Kulioner {
  orders: KulionerOrder[] = [];
  summary: Record<string, number> = {};
  orderIds: string[] = [];

  constructor(fields?: Partial<Kulioner>) {
    Object.assign(this, fields);
  }
}

export class KulionerEntites {
  pagination = new PaginationV2();
  data = new Kulioner();

  constructor(fields?: Partial<KulionerEntites>) {
    Object.assign(this, fields);
  }
}

export class DownloadReportRequest {
  startDate = "";
  endDate = "";
  constructor(fields?: Partial<DownloadReportRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities2(ConvertObjectCamelToSnakeCase(this))
      .queryString;
  }
}

export class KulionerConfirmOrderEntites {
  id = [];

  constructor(fields?: Partial<KulionerConfirmOrderEntites>) {
    Object.assign(this, fields);
  }
}

export class KulionerCycle {
  cutOffTime = "";
  id: number[] = [];

  constructor(fields?: Partial<KulionerCycle>) {
    Object.assign(this, fields);
  }
}

export class UpdateMerchantOrderRequest {
  id = 0;
  quantity = 0;

  constructor(fields?: Partial<UpdateMerchantOrderRequest>) {
    Object.assign(this, fields);
  }
}

export class Merchant {
  orders: KulionerMerchant[] = [];
  orderIds: string[] = [];
  eligibleOrderIds: string[] = [];
  canBeProcessed = false;

  constructor(fields?: Partial<Merchant>) {
    Object.assign(this, fields);
  }
}

export class KulionerMerchantEntites {
  data = new Merchant();

  constructor(fields?: Partial<KulionerMerchantEntites>) {
    Object.assign(this, fields);
  }
}

export class UpdateMerchantOrderResponse {
  id = 0;
  status = "";
  products: UpdateMerchantOrderRequest[] = [];

  constructor(fields?: Partial<UpdateMerchantOrderResponse>) {
    Object.assign(this, fields);
  }
}

export class KulionerUpdateMerchantOrderSummary {
  mustBuy = 0;
  wasBuy = 0;
  notBuy = 0;
  constructor(fields?: Partial<KulionerUpdateMerchantOrderSummary>) {
    Object.assign(this, fields);
  }
}
